




























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ReceiverInfo extends Vue {
    @Prop({ default: () => ({}) })
    private receipt: any;    
}
